import { ACCESS_CODE_PARAM, RESOURCE_KEY_PARAM } from 'pages/integrations/components/lti/constants';

export type CustomParam = {
    name: string;
    value: string;
};

/**
 * Builds the custom parameters that target a specific GMetrix resource in an LTI
 * launch when deep linking is NOT used. `gmxresourcekey` carries the resource's
 * DeliverableControl; `accesscode` is required whenever a resource key is sent.
 */
export const buildCustomParams = (deliverableControl: string, accessCode: string): CustomParam[] => {

    const params: CustomParam[] = [{ name: RESOURCE_KEY_PARAM, value: deliverableControl.trim() }];

    if (accessCode.trim()) {

        params.push({ name: ACCESS_CODE_PARAM, value: accessCode.trim() });

    }

    return params;

};

/** Formats the custom parameters as newline-separated `name=value` pairs for pasting into an LMS. */
export const formatCustomParamsBlock = (params: CustomParam[]): string => params.map(param => `${param.name}=${param.value}`).join('\n');
